import React, { Component } from 'react'
import { JDImage, JDTouchable, JDJumping } from '@jdreact/jdreact-core-lib'
import PropTypes from 'prop-types'

import styles from './styles'

class AdvImage extends Component {
  static propTypes = {
    advData: PropTypes.object.isRequired,
    beforeJump: PropTypes.func
  }

  static defaultProps = {
    advData: {},
    beforeJump: () => {}
  }

  jumpToPage = () => {
    const { advData: { jumpUrl } } = this.props
    if(!jumpUrl || jumpUrl == -1) return
    this.props.beforeJump()
    setTimeout(() => {
      JDJumping.jumpToWeb(jumpUrl).catch(err => {
        console.log('跳转广告链接失败: ', err)
      })
    }, 200)
  }

  render() {
    const { advData: { imgUrl = '' } } = this.props
    if(!imgUrl) return null

    return (
      <JDTouchable style={styles.container} onPress={this.jumpToPage}>
        <JDImage source={{uri: `https:${imgUrl}`}} style={styles.image}/>
      </JDTouchable>
    )
  }
}

export default AdvImage
